/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react';
import { ButtonGroup, InputText, SelectCustom, TextArea } from '@/components';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { ReactComponent as Pen } from '@/assets/images/svg/pen.svg';
import FractionalDeadline from '@/model/FractionalDeadline';
import { SectorTicketMainSettingsContainerProps, ShouldShowModal } from '../../screens/ui';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  name = 'name',
  eventSection = 'eventSection',
  hasHalfPrice = 'hasHalfPrice',
  sequence = 'sequence',
  hasCourtesy = 'hasCourtesy',
  amountCourtesy = 'amountCourtesy',
  printerType = 'printerType',
  printerServerId = 'printerServerId',
  copies = 'copies',
  reprint = 'reprint',
  printBatchNumber = 'printBatchNumber',
  observation = 'observation',
  fractionalPayment = 'fractionalPayment',
  minPayment = 'minPayment',
  maximumPaymentDeadline = 'maximumPaymentDeadline',
  fractionalDeadline = 'fractionalDeadline',
}

export const SectorTicketMainSettingsContent: React.FC<
  Pick<
    SectorTicketMainSettingsContainerProps,
    'formMainSettings' | 'modalConfig' | 'sectorStates' | 'setHasHalfPrice' | 'printerServers'
  >
> = ({ formMainSettings, modalConfig, sectorStates, setHasHalfPrice, printerServers }) => {
  const { formData, formErrors, onChangeFormInput } = formMainSettings;

  const sectorSelected = sectorStates.sectorList.find(
    sector => sector.id === formData[FormInputName.eventSection],
  );

  const copiesOptions = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
  ];

  const printerOptions = [
    { label: 'Maquininha', value: '0' },
    { label: 'Bluetooth', value: '1' },
    { label: 'USB 110mm', value: '2' },
    { label: 'USB 100mm', value: '4' },
    { label: 'WhatsApp', value: '3' },
  ];

  const serversOptions = printerServers.map(data => ({
    label: data.name,
    value: data.id,
  }));

  const fractionalDeadlineOptions = [
    {
      label: 'Minutos',
      value: FractionalDeadline.MINUTE,
    },
    {
      label: 'Horas',
      value: FractionalDeadline.HOUR,
    },
    {
      label: 'Dias',
      value: FractionalDeadline.DAY,
    },
  ];

  return (
    <Fragment>
      <Form
        noValidate={true}
        onSubmit={(e): void => {
          e.preventDefault();
        }}
      >
        <Row>
          <Col md={12}>
            <FormGroup className="mb-2">
              <SelectCustom
                name="eventSection"
                label="Nome do setor"
                placeholder="Digite ou selecione o nome do setor"
                value={formData[FormInputName.eventSection]}
                onChange={e => onChangeFormInput(FormInputName.eventSection)(e?.value as string)}
                error={formErrors.eventSection && formErrors.eventSection[0]}
                options={sectorStates.sectorList.map(sector => ({
                  value: sector.id,
                  label: sector.name,
                }))}
              />
              <div className="d-flex flex-column mb-5" style={{ marginTop: '-20px' }}>
                <span className="d-flex">
                  <div
                    className="mr-5 link-green"
                    onClick={(): void => {
                      modalConfig.onToggle();
                      modalConfig.onShouldShowModal({
                        value: ShouldShowModal.sector,
                        newTitleModal: 'Cadastrar novo setor',
                      });
                    }}
                  >
                    + cadastrar novo setor
                  </div>
                  <div
                    className="link-grey"
                    onClick={(): void => {
                      if (!sectorSelected) {
                        toast.warn('Selecione um setor para editar');
                      } else {
                        modalConfig.onToggle();
                        modalConfig.onShouldShowModal({
                          value: ShouldShowModal.sector,
                          newTitleModal: sectorSelected?.id
                            ? sectorSelected?.name
                            : 'Cadastrar novo setor',
                          sector: sectorSelected,
                        });
                      }
                    }}
                  >
                    <Pen height={12} width={12} /> editar
                  </div>
                </span>
              </div>
            </FormGroup>

            <FormGroup>
              <InputText
                name="name"
                label="Nome do ingresso"
                placeholder="Digite o nome do ingresso"
                value={formData[FormInputName.name]}
                onChange={e => onChangeFormInput(FormInputName.name)(e.target.value)}
                error={formErrors.name && formErrors.name[0]}
              />
            </FormGroup>

            <FormGroup className="mb-2">
              <InputText
                name="sequence"
                label="Sequencia de exibição do ingresso"
                placeholder="Digite a sequencia de exibição do ingresso"
                value={formData[FormInputName.sequence]}
                type="number"
                maxLength={2}
                className="w-input-sm"
                onChange={e => onChangeFormInput(FormInputName.sequence)(e.target.value)}
                error={formErrors.sequence && formErrors.sequence[0]}
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <ButtonGroup
                label="Permitir meia entrada?"
                name="hasHalfPrice"
                value={formData[FormInputName.hasHalfPrice]}
                onChange={e => {
                  onChangeFormInput(FormInputName.hasHalfPrice)(e.target.value);
                  setHasHalfPrice(e.target.value === 'true');
                  /*
              if (e.target.value === 'false') {
                onChangeFormInput(FormInputName.percentageHalfPrice)('');
                onChangeFormInput(FormInputName.amountHalfPrice)('');
              }
              */
                }}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.hasHalfPrice && formErrors.hasHalfPrice[0]}
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <ButtonGroup
                label="Permitir ingresso cortesia?"
                name="hasCourtesy"
                value={formData[FormInputName.hasCourtesy]}
                onChange={e => {
                  onChangeFormInput(FormInputName.hasCourtesy)(e.target.value);
                  if (e.target.value === 'false') {
                    onChangeFormInput(FormInputName.amountCourtesy)('');
                  }
                }}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.hasCourtesy && formErrors.hasCourtesy[0]}
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <InputText
                name="amountCourtesy"
                label="Quantidade de ingressos cortesia"
                placeholder="Ex: 20000"
                maxLength={6}
                className="w-input-sm"
                value={formData[FormInputName.amountCourtesy]}
                onChange={e =>
                  onChangeFormInput(FormInputName.amountCourtesy)(
                    e?.target.value.replace(/\D/g, '') as string,
                  )
                }
                error={formErrors.amountCourtesy && formErrors.amountCourtesy[0]}
                disabled={
                  !formData[FormInputName.hasCourtesy] ||
                  formData[FormInputName.hasCourtesy] === 'false'
                }
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <SelectCustom
                name="printer"
                label="Impressora"
                placeholder="Selecione o tipo de impressora"
                value={formData[FormInputName.printerType]}
                onChange={e => onChangeFormInput(FormInputName.printerType)(e?.value as string)}
                error={formErrors.printer && formErrors.printer[0]}
                options={printerOptions}
              />
            </FormGroup>
            {(formData[FormInputName.printerType] === '2' ||
              formData[FormInputName.printerType] === '4') && (
              <FormGroup className="mb-2">
                <SelectCustom
                  name="printerServerId"
                  label="Servidor"
                  placeholder="Selecione o servidor de impressora"
                  value={formData[FormInputName.printerServerId]}
                  onChange={e =>
                    onChangeFormInput(FormInputName.printerServerId)(e?.value as string)
                  }
                  error={formErrors.printerServerId && formErrors.printerServerId[0]}
                  options={serversOptions}
                />
              </FormGroup>
            )}
            <FormGroup className="mb-2">
              <SelectCustom
                name="copies"
                label="Número de vias (opcional)"
                placeholder="Ex: 1"
                className="w-input-sm"
                value={formData[FormInputName.copies]}
                onChange={e => onChangeFormInput(FormInputName.copies)(e?.value as string)}
                error={formErrors.copies && formErrors.copies[0]}
                options={copiesOptions}
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <ButtonGroup
                label="Reimprimir ingresso? (opcional)"
                name="reprint"
                value={formData[FormInputName.reprint]}
                onChange={e => onChangeFormInput(FormInputName.reprint)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.reprint && formErrors.reprint[0]}
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <ButtonGroup
                label="Imprimir número do lote? (opcional)"
                name="printBatchNumber"
                value={formData[FormInputName.printBatchNumber]}
                onChange={e => onChangeFormInput(FormInputName.printBatchNumber)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.printBatchNumber && formErrors.printBatchNumber[0]}
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <TextArea
                name="observation"
                label="Frase do ingresso (opcional)"
                placeholder="Digite a frase que irá aparecer no ingresso"
                maxLength={250}
                rows={4}
                value={formData[FormInputName.observation]}
                onChange={e => onChangeFormInput(FormInputName.observation)(e.target.value)}
                error={formErrors.observation && formErrors.observation[0]}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup className="mb-2">
              <ButtonGroup
                label="Permitir Camarote Empresarial"
                name="fractionalPayment"
                value={formData[FormInputName.fractionalPayment]}
                onChange={e => onChangeFormInput(FormInputName.fractionalPayment)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.fractionalPayment && formErrors.fractionalPayment[0]}
              />
            </FormGroup>
          </Col>
        </Row>
        {formData[FormInputName.fractionalPayment] === 'true' && (
          <Fragment>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <InputText
                    name="minPayment"
                    label="Pagamento mínimo entrada camarote empresarial!"
                    placeholder="Ex: 20,00"
                    addon="R$"
                    value={formData[FormInputName.minPayment]}
                    onChange={e => {
                      onChangeFormInput(FormInputName.minPayment)(e.target.value);
                    }}
                    error={formErrors.minPayment && formErrors.minPayment[0]}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup className="mb-2">
                  <InputText
                    name="maximumPaymentDeadline"
                    label="Prazo máximo para pagamento da entrada"
                    placeholder="Ex: 20000"
                    type="number"
                    className="w-input-sm"
                    value={formData[FormInputName.maximumPaymentDeadline]}
                    onChange={e =>
                      onChangeFormInput(FormInputName.maximumPaymentDeadline)(
                        e?.target.value.replace(/\D/g, '') as string,
                      )
                    }
                    error={
                      formErrors.maximumPaymentDeadline && formErrors.maximumPaymentDeadline[0]
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-2">
                  <SelectCustom
                    name="fractionalDeadline"
                    label="Prazo"
                    placeholder="Ex: Dias"
                    className="w-input-sm"
                    value={formData[FormInputName.fractionalDeadline]}
                    onChange={e =>
                      onChangeFormInput(FormInputName.fractionalDeadline)(e?.value as string)
                    }
                    error={formErrors.fractionalDeadline && formErrors.fractionalDeadline[0]}
                    options={fractionalDeadlineOptions}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Fragment>
        )}
      </Form>
    </Fragment>
  );
};
